var _path, _path2, _path3, _path4, _g, _path5, _circle, _path6, _path7, _path8, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint0_linear_2835_1054)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2835_1054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint1_linear_2835_1054)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2835_1054)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1071 113H86.8929L90 133H61L64.1071 113Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2835_1054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 113,
    width: 29,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1071 113H86.8929L90 133H61L64.1071 113Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2835_1054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 113,
    width: 25,
    height: 4,
    fill: "#B4DAFF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 59.7C25 53.7906 29.7906 49 35.7 49H114.88C120.789 49 125.58 53.7906 125.58 59.7V102.5C125.58 108.409 120.789 113.2 114.88 113.2H35.7C29.7906 113.2 25 108.409 25 102.5V59.7Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 108,
    r: 3,
    fill: "#1485FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5089 63.1964C32.5089 58.9754 36.6042 55.5536 41.6559 55.5536H109.344C114.396 55.5536 118.491 58.9754 118.491 63.1964V93.7679C118.491 97.9889 114.396 101.411 109.344 101.411H41.6559C36.6042 101.411 32.5089 97.9889 32.5089 93.7679V63.1964Z",
    fill: "#B4DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0089 63.1964C33.0089 59.3319 36.7924 56.0536 41.6559 56.0536H109.344C114.208 56.0536 117.991 59.3319 117.991 63.1964V93.7679C117.991 97.6324 114.208 100.911 109.344 100.911H41.6559C36.7924 100.911 33.0089 97.6324 33.0089 93.7679V63.1964Z",
    stroke: "black",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51 137.5C51 135.015 52.9077 133 55.2609 133H95.7391C98.0923 133 100 135.015 100 137.5C100 139.985 98.0923 142 95.7391 142H55.2609C52.9077 142 51 139.985 51 137.5Z",
    fill: "#B4DAFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2835_1054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.643 41.843H49.5023C45.9916 41.843 43.1455 44.6773 43.1455 48.1737V88.6693C43.1455 92.1656 45.9916 95 49.5023 95H106.643C110.154 95 113 92.1656 113 88.6693V48.1737C113 44.6773 110.154 41.843 106.643 41.843Z",
    fill: "#3E70B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.498 36H46.3568C42.8461 36 40 38.8344 40 42.3307V82.8263C40 86.3227 42.8461 89.157 46.3568 89.157H103.498C107.008 89.157 109.854 86.3227 109.854 82.8263V42.3307C109.854 38.8344 107.008 36 103.498 36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5164 50.457C52.5212 50.0542 52.5237 49.6514 52.531 49.2462C52.5602 47.1667 53.7492 45.951 55.8471 45.9219C57.9132 45.8928 59.9794 45.9146 62.0455 45.9146C72.3763 45.9146 82.707 45.9146 93.0402 45.9146C95.9762 45.9146 96.885 46.8076 96.9118 49.7266C95.372 50.4813 94.1074 51.6338 92.7357 52.6238C87.0562 56.7149 81.3645 60.789 75.6095 64.7757C74.8688 65.2901 74.3328 65.2974 73.5799 64.7757C68.2903 61.1093 62.9811 57.472 57.6525 53.8638C55.9518 52.7112 54.3925 51.3451 52.5164 50.4546V50.457Z",
    fill: "#B4DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5163 50.457C54.3924 51.3475 55.9518 52.7136 57.6525 53.8662C62.9811 57.4744 68.2902 61.1117 73.5799 64.7781C74.3328 65.2998 74.8688 65.2925 75.6095 64.7781C81.3621 60.7914 87.0562 56.7173 92.7357 52.6263C94.1074 51.6363 95.3744 50.4837 96.9118 49.7291L96.924 49.7582C96.9216 50.4983 96.9167 51.2383 96.9143 51.9808C89.8655 57.2221 82.8118 62.456 75.7752 67.7118C74.9224 68.3475 74.1988 68.3087 73.3582 67.7045C67.2815 63.3271 61.1805 58.9813 55.1088 54.5966C54.2024 53.9439 53.1352 53.4634 52.5066 52.4661C52.5066 51.8061 52.5066 51.1461 52.5066 50.4861L52.5163 50.4594V50.457Z",
    fill: "#3F72B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1141 56.0573C97.1141 61.5849 97.1798 67.1124 97.0824 72.6375C97.041 75.0446 96.0323 76.2797 93.3302 76.2603C80.7871 76.1753 68.244 76.2239 55.7009 76.2214C53.5324 76.2214 52.548 75.28 52.5432 73.1592C52.5334 67.7045 52.5407 62.2497 52.5407 56.6664C53.8516 57.0983 54.7457 58.0034 55.7374 58.7071C60.2181 61.8809 64.6453 65.1251 69.0967 68.3402C70.5367 69.3787 72.0279 70.3542 73.4215 71.451C74.2183 72.077 74.8225 72.1328 75.6826 71.5432C80.0805 68.527 84.2493 65.2052 88.5473 62.058C91.2762 60.0586 93.9685 58.0107 96.6779 55.9845C96.8241 56.0088 96.9703 56.0331 97.1165 56.0573H97.1141Z",
    fill: "#B8D7F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2835_1054",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2835_1054",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2835_1054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 59,
    fill: "white",
    transform: "translate(40 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckEmail);
export default __webpack_public_path__ + "static/media/success-check-email.b468001cff431273a570dfd94e5d327e.svg";
export { ForwardRef as ReactComponent };